import React from "react";
import Newsletter_49 from "../component/Newsletter_49";

function Newsletter_49_container() {
  return <Newsletter_49 />;
}

export default Newsletter_49_container;
